import { Button, Card, CardBody } from 'reactstrap';
import { useContext, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useReactTable } from '@tanstack/react-table';

import {
  SelectColumnFilter,
  DateRangeColumnFilter,
  dateBetweenFilterFn,
} from '../../services/filters';

import { CampaignContext } from '../../context/campaign';
import {
  fetchMyCampaign,
  fetchUpdates,
  postCampaignUpdate,
  putCampaignUpdate,
  deleteCampaignUpdate,
} from '../../services/campaign';
import { ICampaignUpdate, MyCampaignResponse } from '../../types/campaign';
import { formatCurrency } from '../../services/helper';
import TableContainer from './components/TableContainer';
import { CampaignHeaderSection } from '../../shared/components/cards/CampaignItemsCard';
import { renderIcon } from '../../shared/components/icons';
import { Loading } from '../../shared/components/Loading';
import { ConfirmModal } from '~/shared/components/ConfirmModal';
import { CampaignUpdateModal } from './components/CampaignUpdateModal';
import toast from 'react-hot-toast';

import moment from 'moment';

export const CampaignFiles = ({}: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
  const [activeFilter, setActiveFilter] = useState('');

  const columns = useMemo(
    () => [
      {
        id: 'select',
        header: ({ table }) => (
          <IntermediateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        ),
        cell: ({ row }) => (
          <div className='px-1'>
            <IndeterminateCheckbox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
              }}
            />
          </div>
        ),
      },
      {
        id: 'filename',
        Header: 'Filename',
        accessorKey: '', // accessor is the "key" in the data
      },
      {
        id: 'date',
        Header: 'Date',
        accessorKey: 'created_date',
      },
      {
        id: 'filetype',
        Header: 'Filetype',
        accessorKey: '',
      },
      {
        id: 'actions',
        Header: 'Actions',
        accessorKey: '',
        accessorFn: (props) => {
          return (
            <span className='d-flex justify-content-end'>
              <Button
                onClick={() => {
                  // const thisUpdate = updates?.find((u) => u.id === props.id);
                  // setEditUpdate(thisUpdate);
                }}
                color='link'
                className='me-2 p-2'
              >
                {renderIcon('expand')}
              </Button>
              <Button
                onClick={() => {
                  // const thisUpdate = updates?.find((u) => u.id === props.id);
                  // setDeleteUpdate(thisUpdate);
                }}
                color='link'
              >
                {renderIcon('download')}
              </Button>
            </span>
          );
        },
      },
    ],
    []
  );

  const data = useMemo(
    () => [
      {
        date: '11/23/2022 02:58:12',
        filename: 'first name is 0',
        filetype: 'jpeg',
      },
    ],
    []
  );

  useEffect(() => {
    if (!campaign) {
      getMyCampaign();
    }
  }, []);

  const getMyCampaign = async () => {
    try {
      const resp: MyCampaignResponse = await fetchMyCampaign();
      if (resp.detail && resp.detail === 'Invalid token.') {
        // Delete localStorage token
        localStorage.removeItem('token');
        history.push('/login');
      }
      campaignDispatch({
        type: 'set_campaign',
        payload: resp,
      });
      setLoading(false);
    } catch (e) {
      console.log('getMyCampaign() e: ', e);
      // Show some error here
    }
  };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useReactTable({ columns, data });

  const filterFiles = (filter) => {
    console.log(filter);
    setActiveFilter(filter);
  };

  return (
    <div className='container__inner'>
      <CampaignHeaderSection
        leftcard={<h1 className='h2'>Files</h1>}
        // contact={campaignCoordinator}
      />
      <div
        className='d-flex'
        style={{
          margin: '0 -40px',
          padding: '8px 40px',
          backgroundColor: '#fef2ea',
        }}
      >
        <Button
          color={activeFilter === 'all' ? 'warning' : ''}
          size='sm'
          onClick={() => filterFiles('all')}
        >
          All Files
        </Button>
        <Button
          color={activeFilter === 'my files' ? 'warning' : ''}
          size='sm'
          onClick={() => filterFiles('my files')}
        >
          My Files
        </Button>
        <Button
          color={activeFilter === 'hhl' ? 'warning' : ''}
          size='sm'
          onClick={() => filterFiles('hhl')}
        >
          HHL Files
        </Button>
      </div>
      <TableContainer
        columns={columns}
        data={data}
        showPaginationComponents={true}
      />
    </div>
  );
};
